import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraFiscalEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportRemitoPDF (remito, renglones, empresa, save) {
      let pdfName = 'remito_'; 
      pdfName = pdfName.concat(remito.numero.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');

      doc.setProperties({
        title: 'Remito',
        subject: 'Remito',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      // let fontName = 'CenturyGothic';
      // let fontBoldName = 'CenturyGothicBold';
      // let fontItalicName = 'CenturyGothicItalic';
      // let fontBoldItalicName = 'CenturyGothicBoldItalic';

      let cadena = '';

      remito.cuit = this.$options.filters.cuit(remito.cuit);

      let positionLeyendaAceptoConforme = 236;
      let positionLeyendaDevolverRemito = 244;
      let positionBultos = 252;
      let positionDatosConformado = 275;
      /* Limite para el salto de página */
      let positionMaxY = 233;
      /* Interlineado */
      let interlineado = 4;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      let positionY = drawCabecera(doc, empresa, remito, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      positionY += 6;
  
      doc.rect(10, positionY - 4, 190, positionLeyendaAceptoConforme - positionY);
      doc.line(30, positionY - 4, 30, positionLeyendaAceptoConforme - 4);

      /* Titulo de los renglones */
      doc.setFont(fontBoldName, 'bold');
      // doc.setFontType('bold');
      doc.setTextColor(60, 60, 60);

      doc.text('CANTIDAD', 12, positionY);
      doc.text('DESCRIPCIÓN', 100, positionY);

      // positionY += 2;
      
      if (renglones) {
        for (let renglonNumero = 1; renglonNumero <= 35; renglonNumero++) {
          /* Verificamos si necesitamos agregar una nueva pagina */
          // if (positionY + interlineado > positionMaxY) {
          //   console.log(renglonNumero, positionY, interlineado, positionMaxY);
          //   /* Agregamos una nueva pagina */
          //   doc.addPage();

          //   positionY = drawCabecera(doc, empresa, remito, 
          //     fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          // }

          positionY += interlineado;

          let renglon = renglones
            .find( renglon => renglon.renglonNumero == renglonNumero);
          if (renglon) {
            // doc.setFontSize(7);
            doc.setFont(fontName, 'normal');
            // doc.setFontType('normal');
            doc.setFontSize(9);
            // doc.setTextColor(151, 148, 149);
            doc.setTextColor(60, 60, 60);
  
            if (renglon.cantidad.trim() != '') {
              let length = renglon.cantidad.trim().length;
              let spaces = (10 - length) / 2;
              
              doc.text(renglon.cantidad.trim(), 14 + spaces, positionY);  
            }
            doc.text(renglon.descripcion.trim(), 35, positionY);
          }
        }
      }

      positionY = positionLeyendaAceptoConforme;
      doc.setFontSize(10);
      doc.setFont(fontBoldName, 'bold');
      doc.setTextColor(60, 60, 60);
      // doc.setFontType('bold');
      doc.text(`Acepto conforme la mercadería de Cervetti Mkt & Eventos`, 56, positionY);

      if (!(/true/i).test(remito.entregaPersonal)) {
        positionY = positionLeyendaDevolverRemito;

        doc.rect(10, positionLeyendaDevolverRemito - 5, 190, 7, 'F');

        doc.setFont(fontBoldName, 'bold');
        doc.setFontSize(12);
        // doc.setFontType('bold');
        doc.setTextColor(255, 255, 255);
        doc.text(`DEVOLVER REMITO CONFORMADO`, 68, positionY);
      }

      positionY = positionBultos;
      doc.rect(10, positionBultos - 5, 190, 16);
      doc.line(120, positionBultos - 5, 120, positionBultos + 11);

      doc.setFont(fontBoldName, 'bold');
      // doc.setTextColor(151, 148, 149);
      doc.setTextColor(60, 60, 60);
      // doc.setFontType('bold');
      if ((/true/i).test(remito.entregaPersonal)) {
        doc.setFontSize(10);
        doc.text(`${remito.formaEntrega}`, 12, positionY);
      } else {
        doc.setFontSize(8);
        doc.text(`Valor Declarado: ${this.$options.filters.moneda(remito.valorDeclarado)}`, 12, positionY);
        positionY += interlineado;
        // doc.text(`Transporte: ${remito.transporte}`, 12, positionY);
        doc.text(`Transporte: ${remito.formaEntrega}`, 12, positionY);
        positionY += interlineado;
        doc.text(`Pago de Flete en Cuenta Corriente - ${empresa.nombreComercial}`, 12, positionY);
      }

      positionY = positionBultos;
      doc.setFont(fontBoldName, 'bold');
      doc.setFontSize(12);

      // doc.setFontSize(12);
      // cadena = `CANTIDAD ${remito.tipoEnvio.trim()}`;
      // let length = cadena.length;
      // let spaces = (50 - length) / 2;
      // doc.text(cadena.trim(), 122 + spaces, positionY);

      // positionY = positionBultos + 8; 
      // doc.setFontSize(14);
      // cadena = `${remito.cantidad.toString()}`;
      // length = cadena.length;
      // spaces = (50 - length) / 2;
      // doc.text(cadena.trim(), 136 + spaces, positionY);
      
      let interlineadoCantidades = 5;
      let tienePaquetes = remito.cantidadPaquetes != 0 ? true : false;
      let tieneBultos = remito.cantidadBultos != 0 ? true : false;
      let tienePallets = remito.cantidadPallets != 0 ? true : false;

      if (tienePaquetes & tieneBultos & tienePallets) {
        positionY = positionBultos;
      } else if ( (tienePaquetes & tieneBultos & !tienePallets) || (tienePaquetes & !tieneBultos & tienePallets) || (!tienePaquetes & tieneBultos & tienePallets)) {
        positionY = positionBultos + 2;
        interlineadoCantidades = 6;
      } else {
        positionY = positionBultos + 5;
      }

      if (remito.cantidadPaquetes != 0) {
        doc.text( `CANTIDAD PAQUETES: ${remito.cantidadPaquetes}` , 128, positionY);
        positionY += interlineadoCantidades;
      }
      if (remito.cantidadBultos != 0) {
        doc.text( `CANTIDAD BULTOS: ${remito.cantidadBultos}` , 128, positionY);
        positionY += interlineadoCantidades;
      }
      if (remito.cantidadPallets != 0) {
        doc.text( `CANTIDAD PALLETS: ${remito.cantidadPallets}` , 128, positionY);
      }

      positionY = positionDatosConformado;

      doc.rect(10, positionDatosConformado - 10, 190, 25);
      doc.line(75, positionDatosConformado - 10, 75, positionDatosConformado + 15);

      doc.setFontSize(7);
      doc.setFont(fontName, 'normal');
      // doc.setFontType('normal');
      cadena = `Aclaración:`;
      doc.text(cadena, 95, positionY, alignRight);
      doc.setLineDash([1, 1], 0);
      doc.line(96, positionY + 0.5, 190, positionY + 0.5);
      positionY += interlineado + 4;
      cadena = `DNI:`;
      doc.text(cadena, 95, positionY, alignRight);
      doc.setLineDash([1, 1], 0);
      doc.line(96, positionY + 0.5, 190, positionY + 0.5);
      
      doc.setLineDash([1, 1], 0);
      doc.line(15, positionY + 0.5, 70, positionY + 0.5);
      positionY += interlineado;
      cadena = `Recibí conforme`;
      doc.text(cadena, 32, positionY);


      drawFooter(doc, remito, fontName, fontBoldName, fontItalicName, fontBoldItalicName);

      if (save) {
        doc.save(pdfName + '.pdf');
      } else {
        window.open(doc.output("bloburl", { filename: 'remito.pdf' } ));
      }

      return;
    },
  }
}

function drawCabecera(doc, empresa, remito, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {
  let alignRight = {
    'align': 'right'
  }

  /* Verificamos si tiene logo asociado */
  let logoAsociado = (empresa.logoWeConnect.trim() != '')? true : false;

  drawCabeceraFiscalEmpresa({
    doc, 
    empresa, 
    fontName, 
    dark: true,
    logoAsociado
  });

  let cadena = '';

  /* Tipo de comprobante */ 
  doc.setTextColor(151, 148, 149);
  doc.rect(98, 8, 14, 14);

  doc.setFont(fontBoldName, 'bold');
  // doc.setFontType('bold');
  doc.setFontSize(24);
  doc.text('R', 102, 16.5);

  doc.setFont(fontName, 'normal');
  // doc.setFontType('normal');
  doc.setFontSize(7);
  doc.text('COD. 091', 99, 20);

  doc.setFontSize(6);
  doc.text('DOCUMENTO NO VALIDO COMO FACTURA', 82, 26);

  //console.log('drawCabecera - Datos empresa');
  // doc.setFontSize(10);
  // doc.setFont(fontBoldName);
  // doc.setFontType('bold');
  doc.setFont(fontBoldName, 'bold');
  // doc.setFontType('bold');
  doc.setFontSize(10);
  doc.setTextColor(60, 60, 60);
  
  let positionY = 18;
  if ((/true/i).test(logoAsociado)) {
    positionY = 40;
  }
  
  let numeroPuntoVenta = "0000" + remito.numeroPuntoVenta;
  numeroPuntoVenta = numeroPuntoVenta.substr(numeroPuntoVenta.length - 4);
  let remitoNumero = "0000000" + remito.numero;
  remitoNumero = remitoNumero.substr(remitoNumero.length - 8);
  cadena = `R ${numeroPuntoVenta}-${remitoNumero}`;
  doc.text(cadena, 200, positionY, alignRight);
  
  doc.setFont(fontName, 'normal');
  doc.setFontSize(10);

  positionY += 5;
  cadena = `Fecha: ${moment(remito.fechaComprobante).format('DD/MM/YYYY')}`;
  doc.text(cadena, 200, positionY, alignRight);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);

  positionY = 55;
  if ((/true/i).test(logoAsociado)) {
    positionY = 60;
  }

  doc.line(10, positionY, 200, positionY);

  doc.setFontSize(8);

  /* Datos del destino */
  positionY += 5;
  cadena = `Destinatario: ${remito.remitoDestino.trim()}`;
  doc.text(cadena, 10, positionY);
  if (remito.documentoNumero.trim() != '') {
    if (remito.documentoTipo.trim() == '') {
      cadena = `Nro.Documento: ${remito.documentoNumero.trim()}`;
    } else {
      cadena = `${remito.documentoTipo.trim()}: ${remito.documentoNumero.trim()}`;
    }
    doc.text(cadena, 120, positionY);
  }
  positionY += 4;
  cadena = `Domicilio: ${remito.direccion.trim()}`;
  doc.text(cadena, 10, positionY);
  positionY += 4;
  cadena = `Localidad: ${remito.localidad.trim()} (${remito.provincia.trim()})`;
  doc.text(cadena, 10, positionY);
  positionY += 4;
  cadena = `Cod. Postal: ${remito.codigoPostal.trim()}`;
  doc.text(cadena, 10, positionY);

  if (remito.presupuestoInternoId != 0) {
    if (remito.ordenTrabajoId != 0) {
      cadena = `Referencia: ${remito.presupuestoNumero.trim()}/${remito.ordenTrabajoId.toString().trim()}`;
      doc.text(cadena, 120, positionY);
    } else {
      cadena = `Referencia: ${remito.presupuestoNumero.trim()}`;
      doc.text(cadena, 120, positionY);
    }
  }

  if (remito.contacto.trim() != '' & remito.contacto.trim() != remito.remitoDestino.trim()) {
    positionY += 4;
    cadena = `Contacto: ${remito.contacto.trim()}`;
    doc.text(cadena, 10, positionY);

    if (remito.presupuestoInternoId != 0) {
      doc.setFont(fontBoldName, 'bold');
      doc.text(remito.cliente.trim(), 120, positionY);
      doc.setFont(fontName, 'normal');
    }
  }

  positionY += 4;
  cadena = `Teléfono: ${remito.contactoTelefono.trim()}`;
  doc.text(cadena, 10, positionY);

  if (remito.contacto.trim() == '' || remito.contacto.trim() == remito.remitoDestino.trim()) {
    if (remito.presupuestoInternoId != 0) {
      doc.setFont(fontBoldName, 'bold');
      doc.text(remito.cliente.trim(), 120, positionY);

      positionY += 4;
      doc.text(remito.accion.trim(), 120, positionY);
      doc.setFont(fontName, 'normal');
    }
  } else {
    doc.setFont(fontBoldName, 'bold');
    doc.text(remito.accion.trim(), 120, positionY);
    doc.setFont(fontName, 'normal');
  }

  return positionY;
}


function drawFooter(doc, remito, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  /* Interlineado */
  // let interlineado = 3;

  doc.setFont(fontName, 'normal');
  // doc.setFontType('normal');

  //let positionY = positionLeyendaY;
}
